import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateBrandImage } from '../../api/brand.ts';
import { UpdateBrandImageRequest } from '../../api/requests/brand-request.ts';

export default function useUpdateBrandImage(): UseMutationResult<
  Awaited<ReturnType<typeof updateBrandImage>>,
  Error,
  UpdateBrandImageRequest
> {
  return useMutation({
    mutationFn: updateBrandImage,
  });
}
